var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31579 10.5391C9.74046 10.5391 12.6316 11.1026 12.6316 13.2789C12.6316 15.4553 9.72192 16 6.31579 16C2.89112 16 0 15.4356 0 13.2602C0 11.0838 2.90882 10.5391 6.31579 10.5391ZM14.3149 4.21053C14.7328 4.21053 15.072 4.55532 15.072 4.9782V5.96873H16.0851C16.5021 5.96873 16.8421 6.31352 16.8421 6.7364C16.8421 7.15928 16.5021 7.50408 16.0851 7.50408H15.072V8.49548C15.072 8.91836 14.7328 9.26316 14.3149 9.26316C13.8979 9.26316 13.5579 8.91836 13.5579 8.49548V7.50408H12.5465C12.1286 7.50408 11.7895 7.15928 11.7895 6.7364C11.7895 6.31352 12.1286 5.96873 12.5465 5.96873H13.5579V4.9782C13.5579 4.55532 13.8979 4.21053 14.3149 4.21053ZM6.31579 0C8.63543 0 10.4948 1.88348 10.4948 4.23313C10.4948 6.58278 8.63543 8.46626 6.31579 8.46626C3.99615 8.46626 2.13673 6.58278 2.13673 4.23313C2.13673 1.88348 3.99615 0 6.31579 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.83ecacc69c9a13d81638454d524950c6.svg";
export { ForwardRef as ReactComponent };